import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { GeneralDialog, LoadingIndicator } from 'sharedComponents';
import { LEVEL, LIMIT_SYMBOL } from './constants';
import { options } from './Limit';
import { IconWarningType } from 'svgIcons/MotionPortalIcons';
import { apiCallStatus } from 'helpers/constants';
import { getDefaultLimitsData } from '../actions';
import { useDispatch } from 'react-redux';

const getDefaultPayload = (item) => {
    return {
        timeseriesKey: item?.timeseriesKey,
        trendkey: item?.trendKey
    };
};

const ResetToDefaultModal = ({ showReset, setShowReset, ...props }) => {
    const { t: translate } = useTranslation();
    const dispatch = useDispatch();
    const { defaultLimitValues, defaultLimtsLoading, item, actions } = props;
    const InValidDefaultLimit = defaultLimitValues?.length && defaultLimitValues[0]?.limits?.length && defaultLimitValues[0]?.limits?.find((dl) => dl?.defaultValue || dl?.defaultValue === 0);

    useEffect(() => {
        if (props?.asset && props?.item) {
            const payload = getDefaultPayload(props?.item);
            dispatch(getDefaultLimitsData(props?.asset?.id, [payload], props?.item));
        }
    }, []);

    const handleDefaultReset = () => {
        const defaultLimitsResponse = defaultLimitValues[0];
        const payload = {
            ...item,
            resetToDefault: true, // Mark as reset to default
            limits: defaultLimitsResponse?.limits?.map((lmt) => {
                return {
                    ...lmt,
                    resetToDefault: true
                };
            })
            // limits: item.limits
            //     .map((limit) => {
            //         const defaultLimit = defaultLimitsResponse?.limits?.find(
            //             (dl) => dl?.currentValue === limit?.limitValue || dl?.id === limit?.limitId
            //         );
            //         return defaultLimit
            //             ? {
            //                 ...limit,
            //                 resetToDefault: true, // Mark as reset to default
            //                 limitValue: defaultLimit?.defaultValue,
            //                 limitDirection: defaultLimit?.limitDirection,
            //                 limitLevel: defaultLimit?.limitLevel,
            //             }
            //             : { ...limit };
            //     })
            //     .filter((limit) => limit?.resetToDefault || limit?.isUserLimit), // Keep only default and personal limits
        };
        actions.postLimitRequest(props?.asset?.id, [payload]);
        setShowReset(false); // Close the modal
    };

    return (
        <GeneralDialog
            modalClassName='reset-default-limits'
            show={showReset}
            close={() => setShowReset(false)}
            title={translate('ABB.Powertrain.Frontend.ResetDefaultLimit', { Limit: item?.displayName })}
            cancelButtonProps={{
                text: translate('ABB.Powertrain.Frontend.cancelLabel'),
                onClick: () => setShowReset(false)
            }}
            acceptButtonProps={{
                text: translate('ABB.Powertrain.Frontend.Reset'),
                onClick: handleDefaultReset,
                disabled: !InValidDefaultLimit
            }}
            closeButton={true}
            persistent={false}
        >
            <div className='default-info-content'>
                <IconWarningType width={24} height={24} />
                <span>{translate('ABB.Powertrain.Frontend.ResetDefalutLimitInfo')}</span>
            </div>
            {defaultLimtsLoading === apiCallStatus.LOADING && <LoadingIndicator />}
            {defaultLimitValues?.length && <>
                <div className='review-default'><span>{translate('ABB.Powertrain.Frontend.ReviewDefault')}</span></div>
                {defaultLimitValues[0]?.limits?.map(limit =>
                    <div className='limit-box-default mb-2' key={limit?.id}>
                        <div className='limit-level-container d-flex align-items-center'>
                            {options?.find((o) => o?.label === limit?.limitLevel)?.prefixIcon} <span className='ms-2'>{options?.find((o) => o?.label === limit?.limitLevel)?.label}</span>
                        </div>
                        <div className='limit-value-fields'>
                            <div className='limit-value-uom disabled'>
                                <input
                                    type='text'
                                    placeholder={translate('ABB.Powertrain.Frontend.inputValue')}
                                    value={`${limit?.limitDirection === LEVEL.UpperLimit || limit?.limitDirection === LEVEL.Upper ? LIMIT_SYMBOL.Greater : LIMIT_SYMBOL.Lower} ${limit?.defaultValue === 0 ? '0' : limit?.defaultValue || ''}`}
                                    name='limitValue'
                                    disabled={true} />
                                {item?.unit && <div className='uom-text'>{item?.unit}</div>}
                            </div>
                        </div>
                    </div>)}
            </>}
        </GeneralDialog >
    );
};

ResetToDefaultModal.propTypes = {
    showReset: PropTypes.bool, // Whether the modal is visible
    setShowReset: PropTypes.func, // Function to toggle the modal visibility
    defaultLimitValues: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]), // Unique identifier for the limit
            limits: PropTypes.arrayOf(
                PropTypes.shape({
                    defaultValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]), // Default value of the limit
                    currentValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]), // Current value of the limit
                    limitDirection: PropTypes.string, // Direction of the limit (e.g., 'UpperLimit', 'LowerLimit')
                    limitLevel: PropTypes.string, // Level of the limit (e.g., 'Alarm', 'Warning')
                })
            ),
        })
    ), // Array of default limit values
    defaultLimtsLoading: PropTypes.string, // Status of the default limits loading process
    item: PropTypes.shape({
        displayName: PropTypes.string, // Display name of the item
        unit: PropTypes.string, // Unit of measurement for the item
        limits: PropTypes.arrayOf(
            PropTypes.shape({
                limitValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]), // Value of the limit
                limitDirection: PropTypes.string, // Direction of the limit
                limitLevel: PropTypes.string, // Level of the limit
                isUserLimit: PropTypes.bool, // Whether the limit is user-defined
            })
        ),
    }), // The item being reset
    actions: PropTypes.shape({
        updateDefaultLimits: PropTypes.func, // Function to update the default limits
        postLimitRequest: PropTypes.func,
    }), // Actions object containing functions
    asset: PropTypes.shape({
        id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]), // Asset ID
    }),
};

export default React.memo(ResetToDefaultModal);
